import React, { useMemo } from "react";
import { Badge } from "@mantine/core";
import moment from "moment";
import { PageList, ENUM_FORM_DISPLAY } from "../../components/pageList";

const apiEntity = "notificationLog";

const formSchema = {
  title: "Notification Log",
  apiEntity,
  display: { mode: ENUM_FORM_DISPLAY.MODAL, size: "sm" },
  initialValues: {},
  layout: { fields: [] },
};

const NotificationLogs = () => {
  const tableSchema = useMemo(
    () => ({
      columns: [
        {
          field: "sentAt",
          headerName: "Sent At",
          width: 160,
          cellRender: (col, data) =>
            data?.sentAt ? moment(data.sentAt).format("YYYY-MM-DD HH:mm") : "",
        },
        { field: "ruleName", headerName: "Rule", width: 180 },
        { field: "targetEntity", headerName: "Entity", width: 100 },
        { field: "field", headerName: "Field", width: 120 },
        { field: "recipientEmail", headerName: "Recipient", width: 200 },
        { field: "subject", headerName: "Subject", width: 240 },
        { field: "cc", headerName: "CC", width: 160 },
        { field: "bcc", headerName: "BCC", width: 160 },
        {
          field: "attachmentNames",
          headerName: "Attachments",
          width: 220,
          cellRender: (col, data) =>
            Array.isArray(data?.attachmentNames)
              ? data.attachmentNames.join(", ")
              : "",
        },
        {
          field: "encrypted",
          headerName: "Encrypted",
          width: 110,
          cellRender: (col, data) => (data?.encrypted ? "Yes" : ""),
        },
        {
          field: "passwordEmailSent",
          headerName: "Password email",
          width: 140,
          cellRender: (col, data) =>
            data?.encrypted ? (data?.passwordEmailSent ? "Sent" : "Not sent") : "",
        },
        {
          field: "status",
          headerName: "Status",
          width: 100,
          cellRender: (col, data) => (
            <Badge
              size="sm"
              color={
                data?.status === "SENT" ? "green" : data?.status === "FAILED" ? "red" : "gray"
              }
            >
              {data?.status}
            </Badge>
          ),
        },
        {
          field: "error",
          headerName: "Error",
          width: 180,
          cellRender: (col, data) => data?.error ?? "",
        },
      ],
    }),
    []
  );

  return (
    <PageList
      apiEntity={apiEntity}
      title="Notification Logs"
      formSchema={formSchema}
      showAddButton={false}
      tableSchema={tableSchema}
      initSort={{ by: "sentAt", order: "desc" }}
    />
  );
};

export default NotificationLogs;
